var $name="languageCodes",$path="configs/languageCodes.js",$this={$name,$path,};module.exports = {
  chinese: 'zh',
  default: 'en',
};
